import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, Divider } from 'material-ui';
import moment from 'moment';

import ConversationAvatar from './ConversationAvatar';
import ConversationTime from './ConversationTime';
import { localize } from '../../../i18n';

const styles = {
  list: {
    backgroundColor: 'white',
  },
  activeItem: {
    color: '#383f45',
    fontWeight: 500,
  },
};

const ConversationList = ({ channels, onSelect, t }) => {
  const isNew = ({ counter }) => counter > 0;

  const getSecondaryText = (channel) => {
    const {
      lastMessage,
      lastMessageAuthor,
    } = channel;

    return lastMessage ? (
      <span style={isNew(channel) && styles.activeItem}>
        <strong>{lastMessageAuthor}</strong>
        <span> &mdash; {lastMessage}</span>
      </span>
    ) : (
      <span>
        <span>---</span><br />
        <i>{t('No messages yet')}.</i>
      </span>
    );
  };

  const getMessageTime = (channel) => {
    const { lastMessageTimestamp } = channel;
    const mt = moment(lastMessageTimestamp);
    const today = moment();

    if (today.isSame(mt, 'day')) {
      return mt.format('hh:mm A');
    }

    if (today.isSame(mt, 'week')) {
      return mt.format('ddd');
    }

    return mt.format('D/M/YY');
  };

  const minHeight = window.innerHeight - 100;

  return (
    <List style={{ ...styles.list, minHeight }}>
      {channels.map(channel => (
        <Fragment key={channel.channelId}>
          <ListItem
            onClick={() => onSelect(channel)}
            style={isNew(channel) ? styles.activeItem : null}
            primaryText={channel.guestName}
            leftAvatar={<ConversationAvatar name={channel.guestName} />}
            secondaryText={getSecondaryText(channel)}
            rightIconButton={<ConversationTime time={getMessageTime(channel)} isNew={isNew(channel)} />}
            secondaryTextLines={2}
          />
          <Divider inset />
        </Fragment>
      ))}
    </List>
  );
};

ConversationList.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default localize(ConversationList);



// WEBPACK FOOTER //
// ./src/views/chat/components/ConversationList.js